module.exports = __webpack_public_path__ + "static/img/jiagoufenxiao.10b5ade3.png";